/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_DocsInputs */

const en_rd_check_docs = /** @type {(inputs: Rd_Check_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spec or docs folder`)
};

const id_rd_check_docs = /** @type {(inputs: Rd_Check_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder spec atau docs`)
};

/**
* | output |
* | --- |
* | "Spec or docs folder" |
*
* @param {Rd_Check_DocsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_docs = /** @type {((inputs?: Rd_Check_DocsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_DocsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_docs(inputs)
	return en_rd_check_docs(inputs)
});